<template>
  <PageLayout :showTab="true">
    <component v-if="_config" :is="temp" />
    <BottomTab />
  </PageLayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import PageLayout from '@c/layout/PageLayout'
import BottomTab from '@c/layout/BottomTab'
export default {
  mixins: [appConfigMixins],
  components: {
    PageLayout,
    BottomTab,
    default1: () => import('@t/home/default1'),
    Venice01: () => import('@t/home/Venice01'),
    forum: () => import('@t/home/forum'),
    forum2: () => import('@t/home/forum2'),
    forum3: () => import('@t/home/forum3'),
    YongLi: () => import('@t/home/YongLi'),
    fh27: () => import('@t/home/fh27'),
    Yabo01: () => import('@t/home/Yabo01'),
    Rongxin: () => import('@t/home/Rongxin'),
    tp: () => import('@t/home/tp'),
    fh22: () => import('@t/home/fh22'),
    fh31: () => import('@t/home/fh31'),
    fh37: () => import('@t/home/fh37'),
    newyaboLottery: () => import('@t/home/newyaboLottery'),
    kslight: () => import('@t/home/kslight'),
    kslight2: () => import('@t/home/kslight2'),
    kslight3: () => import('@t/home/kslight2'),
    dfcp: () => import('@t/home/dfcp'),
    ks: () => import('@t/home/ks'), // 凯时版面只是在XF02基础上调了颜色
    kszl: () => import('@t/home/kszl'), // 凯时-尊龙版面是全新的
    ksob: () => import('@t/home/ksob'), // 凯时-欧宝版面是全新的
    ob: () => import('@t/home/ob'),
    nox: () => import('@t/home/nox'),
    c75: () => import('@t/home/c75'),
    VeniceDark: () => import('@t/home/VeniceDark'),
    jiuyou: () => import('@t/home/jiuyou'),
  },
  computed: {
    temp() {
      //return 'kslight2'
      try {
        return this._config.app_config.configValue.template.index || 'default1'
      } catch {
        return 'default1'
      }
    },
    isLoginFirst() {
      return this._config.app_config.configValue.template && this._config.app_config.configValue.template.isLoginFirst
        ? this._config.app_config.configValue.template.isLoginFirst
        : false
    }
  },
  //如果底部未配置首页则跳转到下一个非im非发现的页面
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  // const toPath = to.fullPath
  // const toPathHasBottom = vm.bottom_router.find(item => item.to == toPath)
  // if(!toPathHasBottom) {
  //   const frastRouter = vm.bottom_router.find(item => item.key != 'IM' && item.key != 'Discovery')
  //   vm.$router.replace(frastRouter.to)
  // }
  //   })
  // },
  created() {
    if (this.isLoginFirst && !this.$store.state.user.token) {
      this.$toast('请登录后操作')
      this.$router.push('/login')
    } else {
      if (this.$store.state.user.token) {
        this.$store.dispatch('user/getUserInfo')
      }

      const toPath = this.$route.fullPath
      const toPathHasBottom = this.bottom_router.find(item => item.to == toPath)
      if (!toPathHasBottom) {
        const frastRouter = this.bottom_router.find(item => item.key != 'IM' )
        this.$router.replace(frastRouter.to)
      }
    }

    //如果底部未配置首页则跳转到下一个非im非发现的页面
    // const toPath = this.$route.fullPath
    // const toPathHasBottom = this.bottom_router.find(item => item.to == toPath)
    // if(!toPathHasBottom) {
    //   const frastRouter = this.bottom_router.find(item => item.key != 'IM' && item.key != 'Discovery')
    //   this.$router.replace(frastRouter.to)
    //   return
    // }

    //强制登录
    // if (this.isLoginFirst) {
    //   if (this.$store.state.user.token) {
    //     this.$store.dispatch("user/getUserInfo");
    //   } else {
    //     this.$toast("请登录后操作");
    //     this.$router.push("/login");
    //   }
    // } else {
    //   if (this.$store.state.user.token) {
    //     this.$store.dispatch("user/getUserInfo");
    //   }
    // }
  }
}
</script>
